import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_FEES_ACTION_TYPE } from '../actions';

const initialState = {
  fees: [],
  redesignedFees: [],
  cureBaseline: null,
  bonaFideAmount: 0,
  bonaFidePoints: 0,
  summary: {},
  view: {},
};

const loanFeesReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case LOAN_FEES_ACTION_TYPE.GET_FEES:
        draft.fees = payload.fees || initialState.fees;
        draft.cureBaseline = payload.cureBaseline || initialState.cureBaseline;
        draft.bonaFideAmount = payload.bonaFideAmount || initialState.bonaFideAmount;
        draft.bonaFidePoints = payload.bonaFidePoints || initialState.bonaFidePoints;
        break;

      case LOAN_FEES_ACTION_TYPE.GET_FEES_V3:
      case LOAN_FEES_ACTION_TYPE.EDIT_FEES_V3:
        draft.redesignedFees = payload.fees || initialState.redesignedFees;
        break;

      case LOAN_FEES_ACTION_TYPE.GET_FEES_SUMMARY:
        return { ...state, summary: payload || {} };

      case LOAN_FEES_ACTION_TYPE.GET_FEES_VIEW:
        draft.view = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanFeesReducer;
